// Copyright (c) 2017 Comsearch, Inc., All rights reserved

const getEntityIdAndDbSet = getState => ({
  entityId: getState().databaseDetails.get('entityId'),
  dbSet: getState().databaseDetails.get('dbSet'),
})

export default getEntityIdAndDbSet
